import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, Spinner, Alert } from "reactstrap";
import { fetchCrPdf } from "./Form/useContractReviewApi";

/**
 * Print preview — when opened, requests the server-rendered PDF, displays it in an iframe,
 * and offers a download. Equivalent to the legacy "Print" button which showed a DevExpress
 * report ribbon preview (Pass 1 §1.10 / §1.15).
 */
export default function PrintPreviewModal({ crId, isOpen, onClose }) {
    const [url, setUrl] = useState(null);
    const [error, setError] = useState("");

    useEffect(() => {
        if (!isOpen || !crId) return;
        let revokeMe = null;
        setError("");
        setUrl(null);

        (async () => {
            try {
                const blobUrl = await fetchCrPdf(crId);
                revokeMe = blobUrl;
                setUrl(blobUrl);
            } catch (e) {
                setError(e?.response?.data ?? e?.message ?? "Could not generate PDF.");
            }
        })();

        return () => { if (revokeMe) URL.revokeObjectURL(revokeMe); };
    }, [isOpen, crId]);

    return (
        <Modal isOpen={isOpen} toggle={onClose} size="xl" backdrop="static">
            <ModalHeader toggle={onClose}>Print Preview — Contract Review #{crId}</ModalHeader>
            <ModalBody style={{ height: "75vh", padding: 0 }}>
                {error && <Alert color="danger" className="m-3">{error}</Alert>}
                {!url && !error && (
                    <div className="d-flex align-items-center justify-content-center" style={{ height: "100%" }}>
                        <Spinner /> <span className="ms-2">Generating PDF…</span>
                    </div>
                )}
                {url && (
                    <iframe
                        title={`CR-${crId}.pdf`}
                        src={url}
                        style={{ width: "100%", height: "100%", border: 0 }}
                    />
                )}
            </ModalBody>
        </Modal>
    );
}
